import { isIOS, isAndroid } from 'react-device-detect';
import * as session from './session.js';
import { downloadPDF } from '../actions/user.js';

/*
 * import { Services } from '@simplybenefits/sb-ui-library';
 * Todo: from Services in the UI Library
 */
const appStore = "https://apps.apple.com/us/app/simply-benefits/id1494221810";
const playStore = "https://play.google.com/store/apps/details?id=com.simplybenefits.app&hl=en_US";

/*
 * const appStore = Services.constants.appStore;
 * const playStore = Services.constants.playStore;
 */

/* This series of functions takes converts the camelCase string to Normal Case */
/**
 * 
 * @param {*} string 
 * @returns 
 */
export const camelToNormalCase = (item) => (
    item.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())
);

/**
 * 
 * @param {*} x
 */
export const numberWithCommas = (x) => Number(x).toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

/**
 * 
 * @param {*} string 
 */
export const snakeCapitalCase = (string) => string.replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/)
    .map((word) => word.toLowerCase().charAt(0)
        .toUpperCase() + word.slice(1))
    .join('_');

/**
 * 
 */
export const checkMobileRedirectToken = () => {
    let token = Boolean(session.getRedirectToken());
    let showWarning = true;

    if (token) {
        showWarning = false;
    }

    return showWarning;
};

/**
 * 
 */
export const setMobileRedirectToken = () => {
    session.setRedirectToken('DO_NOT_SHOW_WARNING');
};

/**
 * 
 */
export const redirect = () => {
    let link = playStore;
    
    if (isAndroid) {

        /*
         * this works for instagram:
         * const url = "intent://instagram.com/#Intent;scheme=https;package=com.instagram.android;end";
         */

        /*
         * this works for local
         * const url = 'exp://192.168.1.190:19000';
         */

        // Todo: will review after app is deployed
        const url = "intent://play.google.ca/#Intent;scheme=simplyBenefits;package=com.simplybenefits.app;end";
        window.location.replace(url);

        // navigate to the Play Store if the app didn't load
        setTimeout(() => {
            window.location.replace(link);
        }, 2000);

        return true;
    }

    if (isIOS) {
        link = appStore;
        const url = "simplyBenefits://";
        window.location.replace(url);

        // navigate to the App Store if the app didn't load
        setTimeout(() => {
            window.location.replace(link);
        }, 2000);

        return true;
    }

    window.location.replace(link);

    return true;
};

/**
 * @param ComponentName
 * @param fileName
 * @param dispatch
 * @param downloadParams
 * @returns {Promise<void>}
 */
export const downloadPDFToBrowser = async (ComponentName, fileName, dispatch, downloadParams = {}) => {
    const base64 = await dispatch(downloadPDF(ComponentName, downloadParams));

    const linkSource = `data:application/pdf;base64,${ base64 }`;
    const downloadLink = document.createElement("a");

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
};